var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
import styled, { css } from "styled-components";
import { tooltip as tooltipTypography } from "../../typography";
import { bonfireGet } from "../../theme";
import FloatingUI from "../../components-internal/FloatingUI";
var toolTipArrowSideLength = 16; // this is actually a square turned 45 degrees and set behind the tooltip
var toolTipCenterAdjustment = (toolTipArrowSideLength / 2 + 1) * -1; // to get it to true center
var diagonalAdjustment = Math.ceil(Math.ceil(Math.sqrt(2) * 16) / 2); // how much room to give the arrow, and how much to offset the position of the tool-tip
var shift = 10; // space between the edge and the arrow for start and end placements
var variants = {
    default: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n    background: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n    padding: 15px;\n    border-radius: 4px;\n    box-sizing: border-box;\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);\n  "], ["\n    ", ";\n    background: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n    padding: 15px;\n    border-radius: 4px;\n    box-sizing: border-box;\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);\n  "])), tooltipTypography, bonfireGet("colors", "backgroundLight"), bonfireGet("colors", "textDark"), bonfireGet("colors", "surfaceVariant")),
    toolTipDark: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    background: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n    padding: 15px;\n    border-radius: 4px;\n    box-sizing: border-box;\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n  "], ["\n    ", ";\n    background: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n    padding: 15px;\n    border-radius: 4px;\n    box-sizing: border-box;\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n  "])), tooltipTypography, bonfireGet("colors", "surfaceDark"), bonfireGet("colors", "textLight"), bonfireGet("colors", "surfaceDark")),
    toolTipHighlight: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n    background: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n    padding: 15px;\n    border-radius: 4px;\n    box-sizing: border-box;\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);\n  "], ["\n    ", ";\n    background: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n    padding: 15px;\n    border-radius: 4px;\n    box-sizing: border-box;\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);\n  "])), tooltipTypography, bonfireGet("colors", "primaryLight"), bonfireGet("colors", "textDark"), bonfireGet("colors", "surfaceVariant")),
    toolTipExtraLight: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n    background: ", ";\n    color: ", ";\n    border: none;\n    padding: 15px;\n    border-radius: 4px;\n    box-sizing: border-box;\n    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.5);\n  "], ["\n    ", ";\n    background: ", ";\n    color: ", ";\n    border: none;\n    padding: 15px;\n    border-radius: 4px;\n    box-sizing: border-box;\n    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.5);\n  "])), tooltipTypography, bonfireGet("colors", "surfaceVariantLight"), bonfireGet("colors", "textDark")),
    toolTipSurfaceLight: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    background: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n    padding: 15px;\n    border-radius: 4px;\n    box-sizing: border-box;\n    box-shadow: 0 0px 6px rgb(0, 0, 3, 0.5);\n  "], ["\n    ", ";\n    background: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n    padding: 15px;\n    border-radius: 4px;\n    box-sizing: border-box;\n    box-shadow: 0 0px 6px rgb(0, 0, 3, 0.5);\n  "])), tooltipTypography, bonfireGet("colors", "surfaceLight"), bonfireGet("colors", "textDark"), bonfireGet("colors", "surfaceAccent"))
};
var Arrow = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  &:before {\n    position: absolute;\n    width: ", "px;\n    height: ", "px;\n    z-index: -1;\n    content: \"\";\n    transform: rotate(45deg);\n    box-sizing: border-box;\n    background: ", ";\n    top: ", ";\n    bottom: ", ";\n    left: ", ";\n    right: ", ";\n    margin: ", ";\n    border-top: ", ";\n    border-right: ", ";\n    border-bottom: ", ";\n    border-left: ", ";\n  }\n"], ["\n  &:before {\n    position: absolute;\n    width: ", "px;\n    height: ", "px;\n    z-index: -1;\n    content: \"\";\n    transform: rotate(45deg);\n    box-sizing: border-box;\n    background: ", ";\n    top: ", ";\n    bottom: ", ";\n    left: ", ";\n    right: ", ";\n    margin: ", ";\n    border-top: ", ";\n    border-right: ", ";\n    border-bottom: ", ";\n    border-left: ", ";\n  }\n"])), toolTipArrowSideLength, toolTipArrowSideLength, function (props) {
    var variant = props.variant;
    switch (variant) {
        case "toolTipDark":
            return bonfireGet("colors", "surfaceDark");
        case "toolTipHighlight":
            return bonfireGet("colors", "primaryLight");
        case "toolTipExtraLight":
            return bonfireGet("colors", "surfaceVariantLight");
        case "toolTipSurfaceLight":
            return bonfireGet("colors", "surfaceLight");
        default:
            return bonfireGet("colors", "backgroundLight");
    }
}, function (props) {
    var placement = props.placement;
    switch (placement) {
        case "bottom":
        case "bottom-start":
        case "bottom-end":
            return "".concat(toolTipCenterAdjustment, "px");
        case "top":
        case "top-start":
        case "top-end":
            return "auto";
        case "left-start":
        case "right-start":
            return "calc(".concat(shift, "px - ").concat(toolTipCenterAdjustment, "px)");
        case "left-end":
        case "right-end":
            return "calc(100% - ".concat(shift - toolTipCenterAdjustment, "px)");
        default:
            return "50%";
    }
}, function (props) {
    var placement = props.placement;
    if (placement === "top" ||
        placement === "top-start" ||
        placement === "top-end") {
        return "".concat(toolTipCenterAdjustment, "px");
    }
    else {
        return "auto";
    }
}, function (props) {
    var placement = props.placement;
    switch (placement) {
        case "left":
        case "left-start":
        case "left-end":
            return "auto";
        case "right":
        case "right-start":
        case "right-end":
            return "".concat(toolTipCenterAdjustment, "px");
        case "top-start":
        case "bottom-start":
            return "calc(".concat(shift, "px - ").concat(toolTipCenterAdjustment, "px)");
        case "bottom-end":
        case "top-end":
            return "calc(100% - ".concat(shift - toolTipCenterAdjustment, "px)");
        default:
            return "50%";
    }
}, function (props) {
    var placement = props.placement;
    switch (placement) {
        case "left":
        case "left-start":
        case "left-end":
            return "".concat(toolTipCenterAdjustment, "px");
        default:
            return "auto";
    }
}, function (props) {
    var placement = props.placement;
    switch (placement) {
        case "top":
        case "top-start":
        case "top-end":
        case "bottom":
        case "bottom-start":
        case "bottom-end":
            return "0 0 0 ".concat(toolTipCenterAdjustment, "px");
        case "left":
        case "left-start":
        case "left-end":
        case "right":
        case "right-start":
        case "right-end":
            return "".concat(toolTipCenterAdjustment, "px 0 0 0");
        default:
            return "0 0 0 0";
    }
}, function (props) {
    var placement = props.placement, variant = props.variant;
    var borderColor = bonfireGet("colors", "surfaceVariant")(props);
    if (variant === "toolTipDark") {
        borderColor = bonfireGet("colors", "surfaceDark")(props);
    }
    if (variant === "toolTipExtraLight") {
        borderColor = bonfireGet("colors", "surfaceVariantLight")(props);
    }
    if ([
        "bottom",
        "bottom-start",
        "bottom-end",
        "left",
        "left-start",
        "left-end"
    ].indexOf(placement) > -1) {
        return "solid 1px ".concat(borderColor);
    }
    return "none";
}, function (props) {
    var placement = props.placement, variant = props.variant;
    var borderColor = bonfireGet("colors", "surfaceVariant")(props);
    if (variant === "toolTipDark") {
        borderColor = bonfireGet("colors", "surfaceDark")(props);
    }
    if (variant === "toolTipExtraLight") {
        borderColor = bonfireGet("colors", "surfaceVariantLight")(props);
    }
    if ([
        "top",
        "top-start",
        "top-end",
        "left",
        "left-start",
        "left-end"
    ].indexOf(placement) > -1) {
        return "solid 1px ".concat(borderColor);
    }
    return "none";
}, function (props) {
    var placement = props.placement, variant = props.variant;
    var borderColor = bonfireGet("colors", "surfaceVariant")(props);
    if (variant === "toolTipDark") {
        borderColor = bonfireGet("colors", "surfaceDark")(props);
    }
    if (variant === "toolTipExtraLight") {
        borderColor = bonfireGet("colors", "surfaceVariantLight")(props);
    }
    if ([
        "top",
        "top-start",
        "top-end",
        "right",
        "right-start",
        "right-end"
    ].indexOf(placement) > -1) {
        return "solid 1px ".concat(borderColor);
    }
    return "none";
}, function (props) {
    var placement = props.placement, variant = props.variant;
    var borderColor = bonfireGet("colors", "surfaceVariant")(props);
    if (variant === "toolTipDark") {
        borderColor = bonfireGet("colors", "surfaceDark")(props);
    }
    if (variant === "toolTipExtraLight") {
        borderColor = bonfireGet("colors", "surfaceVariantLight")(props);
    }
    if ([
        "bottom",
        "bottom-start",
        "bottom-end",
        "right",
        "right-start",
        "right-end"
    ].indexOf(placement) > -1) {
        return "solid 1px ".concat(borderColor);
    }
    return "none";
});
var ToolTipStyle = styled(FloatingUI)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (props) { return (props.variant && variants[props.variant]) || variants.default; });
var ToolTip = function (_a) {
    var isOpen = _a.isOpen, placement = _a.placement, anchorEl = _a.anchorEl, children = _a.children, variant = _a.variant, style = _a.style, allowFlip = _a.allowFlip, divElementProps = __rest(_a, ["isOpen", "placement", "anchorEl", "children", "variant", "style", "allowFlip"]);
    var _b = __read(React.useState(null), 2), arrowEl = _b[0], setArrowEl = _b[1];
    return (React.createElement(ToolTipStyle, __assign({ style: style, isOpen: isOpen, placement: placement, anchorEl: anchorEl, variant: variant, offset: diagonalAdjustment, arrowEl: arrowEl, allowFlip: allowFlip }, divElementProps), function (_a) {
        var _b;
        var placement = _a.placement, middlewareData = _a.middlewareData;
        var _c = (_b = middlewareData.arrow) !== null && _b !== void 0 ? _b : {}, arrowX = _c.x, arrowY = _c.y;
        if (Number.isNaN(arrowX)) {
            arrowX = undefined;
        }
        if (Number.isNaN(arrowY)) {
            arrowY = undefined;
        }
        return (React.createElement(React.Fragment, null,
            children,
            variant &&
                [
                    "toolTipDark",
                    "toolTipHighlight",
                    "toolTipExtraLight",
                    "toolTipSurfaceLight",
                    "default"
                ].indexOf(variant.toString()) > -1 && (React.createElement(Arrow, { ref: setArrowEl, style: {
                    left: arrowX,
                    top: arrowY
                }, variant: variant, placement: placement }))));
    }));
};
ToolTip.defaultProps = {
    portal: true,
    variant: "default",
    allowFlip: true
};
export default ToolTip;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=ToolTip.js.map